// Configuração centralizada da API
// Para desenvolvimento local, use: http://localhost:8000
// Para produção, configure REACT_APP_API_URL=https://sgf-tc1j.onrender.com
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_URL = `${API_BASE_URL}/api/v1`;





























